export default "__VITE_ASSET__Dt_4bZI2__"